import React, { Component } from 'react'
import ItemComentario from './components/ItemComentario'


import { TextField, Button, Typography } from '@material-ui/core';
import View from 'react-flexbox'
import { Item,  } from 'scorpion-core';
import { userUid } from '../../../../../firebase';

export default class Comentarios extends Component {
    constructor(props) {
        super(props);

        this.state = { texto: "" }
        this.addComentario = this.addComentario.bind(this)
    }
    addComentario() {
        if (this.state.texto) {
            let userUid1 = userUid();
            const { input: { value, onChange }, label } = this.props
            let newArr = [];
            if (value)
                newArr = value.slice();
            newArr.splice(0, 0, { texto: this.state.texto, data: new Date(), userUid: userUid1 });
            // newArr.push({ texto: this.state.texto })
            // console.log("Item ", this.state.texto);
            onChange(newArr)
            this.setState({ texto: "" })
        }
    }

    render() {
        const { input: { value, onChange }, label } = this.props
        let listaComents = []
        if (value) {
            listaComents = value.slice();
        }
        return (
            <View column>
                <Typography>{label}</Typography>
                <Item>
                    <TextField
                        multiline
                        value={this.state.texto}
                        onChange={event => this.setState({ texto: event.target.value })}
                        fullWidth
                    />
                    <Button variant="contained" color="primary" size="small" style={{ margin: 5, height: 33, paddingLeft: 15, paddingRight: 15 }} onClick={this.addComentario}>
                        Adicionar
                    </Button>
                </ Item>
                {listaComents.map((comentario, index) => <ItemComentario key={index} comentario={comentario} />)}

            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Comentarios/Comentarios.js